"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MediaBox = exports.Media = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _draftjsToHtml = _interopRequireDefault(require("draftjs-to-html"));

var _box = _interopRequireDefault(require("./box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mediaBaseUrl = "".concat(ENV.imageStoreBaseUrl, "/contentbox");

var Media = function Media(_ref) {
  var isImage = _ref.isImage,
      mediaUrl = _ref.mediaUrl;

  if (isImage) {
    return /*#__PURE__*/_react["default"].createElement("img", {
      src: mediaUrl,
      className: "media",
      alt: ""
    });
  }

  return /*#__PURE__*/_react["default"].createElement("video", {
    className: "media",
    preload: "none",
    autoPlay: true,
    controls: true,
    controlsList: "nodownload",
    muted: true,
    poster: mediaUrl,
    src: mediaUrl
  }, /*#__PURE__*/_react["default"].createElement("source", {
    type: "video/mp4",
    src: mediaUrl,
    title: ""
  }));
};

exports.Media = Media;
Media.propTypes = {
  isImage: _propTypes["default"].bool.isRequired,
  mediaUrl: _propTypes["default"].string.isRequired
};

var MediaBox = function MediaBox(_ref2) {
  var contentBox = _ref2.contentBox;
  var mediaUrl = mediaBaseUrl + contentBox.mediaUrl;
  var isImage = mediaUrl.substring(mediaUrl.length - 3, mediaUrl.length) === 'png';
  var contentBoxClass = 'media-box-left';
  var content = [/*#__PURE__*/_react["default"].createElement(Media, {
    key: "media-box-".concat(contentBox.id, "-media"),
    mediaUrl: mediaUrl,
    isImage: isImage
  }), /*#__PURE__*/_react["default"].createElement("div", {
    key: "media-box-".concat(contentBox.id, "-text"),
    dangerouslySetInnerHTML: {
      __html: (0, _draftjsToHtml["default"])(contentBox.text)
    }
  })];

  if (contentBox.mediaPosition === 'RIGHT') {
    contentBoxClass = 'media-box-right';
    content = [/*#__PURE__*/_react["default"].createElement("div", {
      key: "media-box-".concat(contentBox.id, "-text"),
      dangerouslySetInnerHTML: {
        __html: (0, _draftjsToHtml["default"])(contentBox.text)
      }
    }), /*#__PURE__*/_react["default"].createElement(Media, {
      key: "media-box-".concat(contentBox.id, "-media"),
      mediaUrl: mediaUrl,
      isImage: isImage
    })];
  }

  if (contentBox.mediaPosition === 'FULL') {
    contentBoxClass = 'media-box-full';
    content = /*#__PURE__*/_react["default"].createElement(Media, {
      mediaUrl: mediaUrl,
      isImage: isImage
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_box["default"], {
    className: contentBoxClass
  }, content);
};

exports.MediaBox = MediaBox;
MediaBox.propTypes = {
  contentBox: _propTypes["default"].shape({
    mediaUrl: _propTypes["default"].string,
    mediaPosition: _propTypes["default"].string,
    media: _propTypes["default"].bool,
    text: _propTypes["default"].oneOfType([_propTypes["default"].shape({
      blocks: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired
    }), _propTypes["default"].string]),
    category: _propTypes["default"].string,
    id: _propTypes["default"].number
  })
};
MediaBox.defaultProps = {
  contentBox: null
};
var _default = MediaBox;
exports["default"] = _default;